import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getMailboxForwardingConfigurationService from '../services/getMailboxForwardingConfigurationService';

export default action('initMailboxForwardingConfiguration')(
    async function initMailboxForwardingConfiguration() {
        store.mailboxForwardingConfiguration = await getMailboxForwardingConfigurationService();
    }
);
